/**
 * Prose the product builds out of data rather than out of a copy deck.
 *
 * Here, and not beside either caller, because these are house style rather than logic:
 * the console and the lesson player both list things at a learner, and two copies of the
 * rule is how one of them acquires a serial comma.
 */
/** `a`, `a and b`, `a, b and c` — the serial comma is not this repository's house style. */
export function serialList(words) {
    if (words.length <= 1)
        return words[0] ?? '';
    return `${words.slice(0, -1).join(', ')} and ${String(words.at(-1))}`;
}
//# sourceMappingURL=prose.js.map